import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import React, { useRef } from 'react'

import { type TabId, TABS } from './data'

type Props = {
  selectedCategory: TabId
  setSelectedCategory: React.Dispatch<React.SetStateAction<TabId>>
}

const TabsBar = ({ selectedCategory, setSelectedCategory }: Props) => {
  const liftRef = useRef<HTMLDivElement>()

  useGSAP(() => {
    const elem = document.querySelector(`.tab_${selectedCategory}`)
    if (!elem) {
      return
    }

    const elementRect = elem.getBoundingClientRect()
    const parentRect = elem.parentElement.getBoundingClientRect()

    gsap.to(liftRef.current, {
      left: elementRect.left - parentRect.left + elem.parentElement.scrollLeft,
      width: elem.clientWidth,
      duration: 0.3,
      ease: 'power2.out',
    })
  }, [selectedCategory])

  return (
    <div className="no-scrollbar relative flex flex-nowrap gap-8 overflow-x-auto">
      {TABS.map(({ id, title }) => (
        <button
          key={id}
          className={`tab_${id} group-[.is-dark-mode]/menu:text-white-50 pb-[10px] whitespace-nowrap hover:opacity-60`}
          type="button"
          onClick={() => {
            setSelectedCategory(id)
          }}
        >
          {title}
        </button>
      ))}
      <div
        ref={liftRef}
        className="bg-amplification-black-premium group-[.is-dark-mode]/menu:bg-white-50 absolute bottom-0 h-px"
      />
    </div>
  )
}

export default TabsBar
